export default __webpack_public_path__ + "static/media/x.f01924cf.svg";